let baseURI = "https://sports-clicksco.herokuapp.com"

export default baseURI;